import { Controller } from 'stimulus';
import Collapse from 'bootstrap/js/src/collapse';

export default class extends Controller {
  static targets = ['collapse'];

  static values = {
    /** When set (e.g. "(min-width: 768px)"), expand collapse and check the toggle when viewport matches. */
    expandWhenWide: String,
  };

  connect() {
    this.collapse = Collapse.getOrCreateInstance(this.collapseTarget, {
      toggle: false,
    });

    if (
      this.hasExpandWhenWideValue &&
      window.matchMedia(this.expandWhenWideValue).matches
    ) {
      this.collapse.show();
      this.setCheckboxChecked(true);
    }
  }

  toggleCollapse() {
    const willBeShown = !this.collapseTarget.classList.contains('show');
    this.collapse.toggle();
    this.setCheckboxChecked(willBeShown);
  }

  setCheckboxChecked(checked) {
    const checkbox = this.element.querySelector('input[type="checkbox"]');
    if (checkbox) checkbox.checked = checked;
  }
}
